var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceAccessNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.1329C17.3599 6.30612 16.7699 6.64427 16.2929 7.12132L9.12132 14.2929C8.64427 14.7699 8.30612 15.3599 8.1329 16H17C17.5523 16 18 15.5523 18 15V6.1329ZM20 6H35C35.5523 6 36 6.44772 36 7V20C36 20.5523 36.4477 21 37 21C37.5523 21 38 20.5523 38 20V7C38 5.34315 36.6569 4 35 4H19C17.4542 4 15.9717 4.61406 14.8787 5.70711L7.70711 12.8787C6.61406 13.9717 6 15.4542 6 17V41C6 42.6569 7.34315 44 9 44H22C22.5523 44 23 43.5523 23 43C23 42.4477 22.5523 42 22 42H9C8.44772 42 8 41.5523 8 41V18H17C18.6569 18 20 16.6569 20 15V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 35C27 32.7909 28.7909 31 31 31H39C41.2091 31 43 32.7909 43 35V41C43 43.2091 41.2091 45 39 45H31C28.7909 45 27 43.2091 27 41V35ZM31 33C29.8954 33 29 33.8954 29 35V41C29 42.1046 29.8954 43 31 43H39C40.1046 43 41 42.1046 41 41V35C41 33.8954 40.1046 33 39 33H31Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 28C31 26.3431 32.3431 25 34 25H36C37.6569 25 39 26.3431 39 28V32H37V28C37 27.4477 36.5523 27 36 27H34C33.4477 27 33 27.4477 33 28V32H31V28Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 16C23 15.4477 23.4477 15 24 15H32C32.5523 15 33 15.4477 33 16C33 16.5523 32.5523 17 32 17H24C23.4477 17 23 16.5523 23 16ZM11 22C11 21.4477 11.4477 21 12 21H32C32.5523 21 33 21.4477 33 22C33 22.5523 32.5523 23 32 23H12C11.4477 23 11 22.5523 11 22ZM11 28C11 27.4477 11.4477 27 12 27H28C28.5523 27 29 27.4477 29 28C29 28.5523 28.5523 29 28 29H12C11.4477 29 11 28.5523 11 28ZM11 34C11 33.4477 11.4477 33 12 33H24C24.5523 33 25 33.4477 25 34C25 34.5523 24.5523 35 24 35H12C11.4477 35 11 34.5523 11 34Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAccessNv);
export default __webpack_public_path__ + "static/media/InvoiceAccess_nv.56980a0a964a415c496b9af8da22a419.svg";
export { ForwardRef as ReactComponent };